import * as THREE from 'three'

export function createWireframeOverlay({ scene, params }) {
  const overlays = new Map()
  const material = new THREE.LineBasicMaterial({
    color: new THREE.Color(params.wireframeColor),
    transparent: true,
    opacity: params.wireframeOpacity,
    depthTest: true,
    toneMapped: false
  })

  function refresh() {
    material.color.set(params.wireframeColor)
    material.opacity = params.wireframeOpacity

    if (!params.wireframe) {
      clear()
      return
    }

    const targets = collectWireframeTargets(scene)

    for (const [target, overlay] of overlays) {
      if (!targets.includes(target) || overlay.userData.sourceGeometry !== target.geometry) {
        removeOverlay(target, overlay)
      }
    }

    for (const target of targets) {
      if (!overlays.has(target)) {
        addOverlay(target)
      }
    }
  }

  function setEnabled(enabled) {
    params.wireframe = enabled
    refresh()
  }

  function clear() {
    for (const [target, overlay] of overlays) {
      removeOverlay(target, overlay)
    }
  }

  function dispose() {
    clear()
    material.dispose()
  }

  function addOverlay(target) {
    const geometry = new THREE.WireframeGeometry(target.geometry)
    const overlay = new THREE.LineSegments(geometry, material)
    overlay.userData.isWireframeOverlay = true
    overlay.userData.sourceGeometry = target.geometry
    overlay.renderOrder = target.renderOrder + 1
    target.add(overlay)
    overlays.set(target, overlay)
  }

  function removeOverlay(target, overlay) {
    target.remove(overlay)
    overlay.geometry.dispose()
    overlays.delete(target)
  }

  return {
    refresh,
    setEnabled,
    dispose
  }
}

function collectWireframeTargets(scene) {
  const targets = []

  scene.traverse((object) => {
    if (object.userData.isWireframeOverlay) {
      return
    }

    if (!object.isMesh || !object.geometry?.isBufferGeometry) {
      return
    }

    targets.push(object)
  })

  return targets
}
